import { styled } from '@linaria/react';
import { colors, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${colors.white};
  border: 1px solid ${semantic.border.subtle};
  border-radius: 12px;
  padding: ${space[5]};
`;
